import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HeaderView from "./Views/AppContentView";
import ComingSoon from "./Components/ComingSoonSection/ComingSoon";  

function App() {
  return (
    <Router basename="">
      <div className="App">
        <Routes>
          {/* Show ComingSoon at the root URL */}
          <Route path="/" element={<ComingSoon />} />

          {/* Show full website when accessing /website */}
          <Route path="/website" element={<HeaderView />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
